import * as actions from 'actions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.CHAT_SCHEDULE_FETCH: {
      return INITIAL_STATE;
    }

    case actions.CHAT_SCHEDULE_FETCH_SUCCESS: {
      return action.result.scheduledChatSessions;
    }

    default:
      return state;
  }
};





/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatScheduledSessions/reducer.js
 **/